/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-15 17:18:56
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-12 14:50:58
 * @name: 主页导航
 * @Description: 主页导航
 * @FilePath: \project\src\config\indexRouterLink.config.js
 * @Author: desktop
 */
export const indexRouterLinkConfig = [
  // {
  //   label: '售前',
  //   children: [
  //     {
  //       label: '延期审批',
  //       url: '/index/delay',
  //       icon: require('@/assets/image/delay-approve.png'),
  //     },
  //     {
  //       label: '特价审批',
  //       url: '/index/bargainPrice',
  //       icon: require('@/assets/image/bargainPrice-approve.png'),
  //     },
  //     {
  //       label: '支付确认',
  //       url: '/index/payConfirm',
  //       icon: require('@/assets/image/pay-confirm.png'),
  //     },
  //     {
  //       label: '我的订单',
  //       url: '/index/myOrder',
  //       icon: require('@/assets/image/my-order.png'),
  //     }
  //   ]
  // },
  {
    label: '售后',
    children: [
      {
        label: '我的售后',
        url: '/index/afterSale',
        icon: require('@/assets/image/my-afterSale.png'),
      },
      {
        label: '待审批',
        url: '/index/afterSaleWaitApprove',
        icon: require('@/assets/image/wait-approve.png'),
      },
      {
        label: '待确认',
        url: '/index/afterSaleWaitConfirm',
        icon: require('@/assets/image/wait-confirm.png'),
      },
      {
        label: '待处理',
        url: '/index/afterSaleWaitDeal',
        icon: require('@/assets/image/wait-deal.png'),
      }
    ]
  }
] 